/**
 * Utility functions for highlighting search terms in text
 */

export interface HighlightMatch {
  text: string;
  isHighlighted: boolean;
}

/**
 * Split text into segments with highlighted matches
 * @param text - The text to search in
 * @param query - The search query
 * @returns Array of text segments with highlight flags
 */
export function getHighlightedSegments(
  text: string,
  query: string
): HighlightMatch[] {
  if (!query || !text) {
    return [{ text, isHighlighted: false }];
  }

  const normalizedQuery = query.trim().toLowerCase();
  
  // Don't highlight if query is too short (< 3 chars by default)
  if (normalizedQuery.length < 3) {
    return [{ text, isHighlighted: false }];
  }

  const normalizedText = text.toLowerCase();
  const segments: HighlightMatch[] = [];
  let lastIndex = 0;

  // Find all occurrences of the query
  let index = normalizedText.indexOf(normalizedQuery);
  
  while (index !== -1) {
    // Add text before match
    if (index > lastIndex) {
      segments.push({
        text: text.substring(lastIndex, index),
        isHighlighted: false,
      });
    }

    // Add matched text
    segments.push({
      text: text.substring(index, index + normalizedQuery.length),
      isHighlighted: true,
    });

    lastIndex = index + normalizedQuery.length;
    index = normalizedText.indexOf(normalizedQuery, lastIndex);
  }

  // Add remaining text
  if (lastIndex < text.length) {
    segments.push({
      text: text.substring(lastIndex),
      isHighlighted: false,
    });
  }

  return segments;
}

